import loadable from '@loadable/component';

const AccountManager = loadable(
  () => import(/* webpackChunkName: "user" */ './manager')
);
const SettingsPage = loadable(
  () => import(/* webpackChunkName: "user" */ './settings')
);
const SignupConfirm = loadable(
  () => import(/* webpackChunkName: "user" */ './confirm')
);
const VerifyEmail = loadable(
  () => import(/* webpackChunkName: "user" */ './verify-email')
);
const EmailChangeConfirm = loadable(
  () =>
    import(
      /* webpackChunkName: "user" */ './settings/components/email-change-confirm'
    )
);
const RecoverLinkSent = loadable(
  () =>
    import(/* webpackChunkName: "user" */ './forgot-password/recover-link-sent')
);

export {
  AccountManager,
  SettingsPage,
  SignupConfirm,
  VerifyEmail,
  EmailChangeConfirm,
  RecoverLinkSent,
};
